import { ProgramsLayout } from '@components/buzzkuri/shared/layouts/Programs'
import { BuzzkuriBreadcrumb } from '@components/buzzkuri/shared/uiParts/breadcrumb/BuzzkuriBreadcrumb'
import { InitProgramNavList } from '@context/ProgramNavList/InitProgramNavList'
import { ProgramsPathsContext } from '@context/ProgramsPaths/Context'
import { ProgramsListPageRes } from '@type/buzzkuri/programs'
import { useContext, useEffect } from 'react'
import { CategoryNavList } from '../Programs/CategoryNavList'
import { TargetProgramList } from '../ProgramsSlugs/ProgramCategory/TargetProgramList'

export const ProgramsListPage = ({
  pageContent,
  business,
  slugs,
}: ProgramsListPageRes & { slugs: string }): JSX.Element => {
  const { title = '', totalProgramCount, programCategories } = pageContent
  const { init } = useContext(ProgramsPathsContext)
  useEffect(() => init, [init])

  InitProgramNavList({ totalProgramCount, programCategories })

  return (
    <ProgramsLayout {...{ business }}>
      <>
        <div className="">
          <div className="mt-[3.2vw] lg:mt-[2.4vw]">
            <BuzzkuriBreadcrumb
              currentPathName={title.replace(
                'プログラム一覧(対面/オンライン)',
                'プログラム'
              )}
            />
          </div>

          <div className="mt-[13.6vw] lg:mt-[2.7vw] lg:max-w-[62.5vw]">
            <TargetProgramList
              slug={title.replace('のプログラム一覧(対面/オンライン)', '')}
              heading={title}
              isMajorHeading
              MainHeadingTag="h1"
              {...pageContent}
              slugs={slugs}
              ProgramHeadingTag="h2"
            />
          </div>

          <div className="mt-[16vw] lg:mt-[6.3vw]">
            <CategoryNavList />
          </div>
        </div>
      </>
    </ProgramsLayout>
  )
}
